var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "valid-disclaimer mt-4 d-flex gap-3 align-items-center"
  }, [_c('div', {
    staticClass: "exclaim-bg"
  }, [_c('i', {
    staticClass: "fa-solid fa-exclamation"
  })]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" A valid license upload is required to continue. Please upload your license(s) to proceed. ")])]);
}]

export { render, staticRenderFns }